import { useState } from "react";

export function useComponentState() {
    const states = {
        DEFAULT: "DEFAULT",
        LOADING: "LOADING",
        SUCCESS: "SUCCESS",
        ERROR: "ERROR"
    };

    const [currentState, changeStateTo] = useState(states.DEFAULT);

    return [currentState, changeStateTo, states];
}
